<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="thkMaterials">
      <div slot="toolbar">
        <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open()">新建</el-button>
        <!--        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>-->
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="规格描述">
            <el-input v-model.trim="filter.materialName" clearable/>
          </vm-search>
          <vm-search label="变频器型号">
            <el-input v-model.trim="filter.param1" clearable/>
          </vm-search>
          <vm-search label="机房形式">
            <el-input v-model.trim="filter.param2" clearable/>
          </vm-search>
          <vm-search label="Q00 In(A)">
            <el-input v-model.trim="filter.param3" clearable/>
          </vm-search>
          <vm-search label="曳引机">
            <el-input v-model.trim="filter.param4" clearable/>
          </vm-search>
          <vm-search label="集成式ARP">
            <el-input v-model.trim="filter.param5" clearable/>
          </vm-search>
          <vm-search label="K00 In(A)">
            <el-input v-model.trim="filter.param6" clearable/>
          </vm-search>
          <vm-search label="标准">
            <el-input v-model.trim="filter.param7" clearable/>
          </vm-search>
          <vm-search label="备注">
            <el-input v-model.trim="filter.note" clearable/>
          </vm-search>
          <vm-search label="创建人">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialNo" align="center" width="100" label="物料号" fixed="left"/>
      <el-table-column prop="materialName" align="center" width="120" label="规格描述" fixed="left"/>
      <el-table-column prop="param1" align="center" label="变频器型号" width="110"/>
      <el-table-column prop="param2" align="center" label="机房形式" width="80"/>
      <el-table-column prop="param3" align="center" label="Q00 In(A)" width="80"/>
      <el-table-column prop="param4" align="center" label="曳引机" width="160"/>
      <el-table-column prop="param5" align="center" label="集成式ARP" width="90"/>
      <el-table-column prop="param6" align="center" label="K00 In(A)" width="100"/>
      <el-table-column prop="param7" align="center" label="标准" width="80"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column prop="creatorName" align="center" width="80" label="创建人"/>
      <el-table-column prop="updateTime" align="center" width="140" label="更新时间"/>
      <el-table-column prop="createTime" align="center" width="140" label="创建时间"/>
      <el-table-column
          label="操作"
          align="center" width="160" fixed="right"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <!--          <el-button type="primary" v-if="editAuth" @click="edit(scope.row,1)">复制</el-button>-->
          <el-button type="primary" v-if="editAuth" :disabled="scope.row.status==1" @click="edit(scope.row,0)">编辑
          </el-button>
          <el-button type="primary" v-if="approveAuth&&scope.row.status==0" @click="approve(scope.row)">审核</el-button>
          <el-button type="primary" v-if="approveAuth&&scope.row.status==1" @click="unApprove(scope.row)">反审核
          </el-button>
          <el-button type="danger" v-if="editAuth" :disabled="scope.row.status==1" @click="oneDelete(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </vm-table>
    <thk-material-box-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import ThkMaterialBoxEdit from "@/views/information/ThkMaterial/ThkMaterialBoxEdit.vue";

  export default {
    name: "ThkMaterialBoxList",
    components: {ThkMaterialBoxEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        importLoading: false,
        exportLoading: false,
        editAuth: this.$auth(516),
        approveAuth: this.$auth(517),
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled: false,
        filter: {
          materialType: 151,
          materialNo: "",
          materialName: "",
          param1: "",
          param2: "",
          param3: "",
          param4: "",
          param5: "",
          param6: "",
          param7: "",
          creatorName: "",
          note: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      approve(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定审核吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "thkMaterials/approve", ids).then(() => {
            this.getList(-1);
            this.$message.success("审核成功");
          });
        });
      },
      unApprove(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定反审核吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "thkMaterials/unApprove", ids).then(() => {
            this.getList(-1);
            this.$message.success("反审核成功");
          });
        });
      },
      oneDelete(row) {
        let ids = [];
        ids.push(row.pkid);
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .post("basic", "thkMaterials/delete", ids).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      edit(row, isCopy) {
        this.$refs.editPage.open(row.pkid, isCopy);
      },

    },
  };
</script>
<style lang="scss" scoped>
</style>
